import "./Footer.css";

export const Footer = () => {
    return (
        <div className="footer_main">
            <div className="footer">
                <div>
                    <img className="footer_logo" src="https://t3.ftcdn.net/jpg/02/62/18/36/360_F_262183660_0nbXAUolsU7TqtELicdIOlbwTuz7oiGe.jpg" alt="" />
                </div>
                <div className="Contact_info">
                    <p>Contact Information</p>
                    <p>+917842254142</p>
                    <p>Spring road 41 street New Delhi- 110022</p>
                </div>
                <div className="Contact_info">
                    <p>Opning Hours</p>
                    <p>Sunday-Saturday <span>10AM-5PM</span></p>
                    <p>Monday-Friday <span>10AM-8PM</span></p>
                </div>
            </div>
           <p className="footer_p">Choose Flowers Shop, Inc for hand-arranged fresh flower delivery today in Spring road, Khajan road</p>
            <p className="footer_p">Flowers Shop offers flower delivery in and around Spring road, as well as nationwide delivery through our reliable florist network! Flowers Shop provides same-day flower delivery for your last-minute gift needs in Spring road, Khajan road as well.</p>
        </div>
    )
}